/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'

/**
 * Component
 */
export default function BigLinks({ className, links = [] }) {
  return (
    <div className={className + ' big-links__group'}>
      {links.map(link => (
        <a key={link.text + link.href} className="big-links" href={link.href} target="_blank">
          {link.text}
        </a>
      ))}
    </div>
  )
}
